import React from 'react'

import { IconProps } from './types'

const ChevronDown: React.FC<IconProps> = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    stroke={color}
    {...rest}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
)
ChevronDown.defaultProps = {
  size: 24,
  color: 'currentColor',
}

export default ChevronDown
